
const digest = '334935878936888156dfcdcc555c7578c07efed287b527bca74a6595a555f68c';
const classes = {"wrapper":"_wrapper_1i2iw_1"};
const css = `._wrapper_1i2iw_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  padding: 16px 24px;
  border: 1px solid #eaedf3;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-top: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  